import { useEffect, useState } from 'react';
import { CatalogItemsLimits } from '../../product-catalog-es.types';
import { resolveVisibleSectionId } from '../utils/catalogSectionScroll.utils';

interface UseCatalogSectionScrollSpyParams {
  scrollParent: HTMLElement | null;
  stickyToolbar: HTMLElement | null;
  stickyFilterBar: HTMLElement | null;
  sectionLimits: CatalogItemsLimits[];
}

export const useCatalogSectionScrollSpy = ({
  scrollParent,
  stickyToolbar,
  stickyFilterBar,
  sectionLimits,
}: UseCatalogSectionScrollSpyParams) => {
  const [visibleSectionId, setVisibleSectionId] = useState<string>();

  useEffect(() => {
    if (!scrollParent) {
      return;
    }

    let frame = 0;

    const measure = () => {
      frame = 0;
      const sectionId = resolveVisibleSectionId({
        scrollParent,
        stickyToolbar,
        stickyFilterBar,
        sectionLimits,
      });

      if (sectionId) {
        setVisibleSectionId(sectionId);
      }
    };

    const scheduleMeasure = () => {
      if (frame) {
        return;
      }

      frame = requestAnimationFrame(measure);
    };

    scrollParent.addEventListener('scroll', scheduleMeasure, { passive: true });
    scheduleMeasure();

    return () => {
      scrollParent.removeEventListener('scroll', scheduleMeasure);
      cancelAnimationFrame(frame);
    };
  }, [scrollParent, stickyToolbar, stickyFilterBar, sectionLimits]);

  return visibleSectionId;
};
